var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeIconEarthquake708361(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1214_56)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1214_56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.0001,
    cy: 15.0001,
    r: 13.9583,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.8056 7.66666L11.1667 9.33332L10.3889 8.58332L9.6111 7.83332L7.80556 9.61111L6 11.3889V17.4444V23.5H14.8889H23.7778V17.4444V11.3889L21.9722 9.61111L20.1667 7.83332L19.3889 8.58332L18.6111 9.33332L16.9722 7.66666C16.0556 6.74999 15.1389 6 14.8889 6C14.6389 6 13.7222 6.74999 12.8056 7.66666ZM16.4167 8.77778C17.5556 9.94445 17.6944 10.1944 17.3889 10.5833C16.9167 11.1389 16.75 11.1111 15.75 10.2778L14.8889 9.55555L14.0278 10.2778C13.0278 11.1111 12.8611 11.1389 12.3889 10.5833C12.0833 10.1944 12.2222 9.94445 13.3611 8.77778C14.1111 7.99999 14.8056 7.38889 14.8889 7.38889C14.9722 7.38889 15.6667 7.99999 16.4167 8.77778ZM10.1111 9.69445C10.3611 9.97222 10.0556 10.4444 8.77777 11.6944C7.1111 13.3333 7.1111 13.3333 7.1111 12.5278C7.1111 11.9444 7.44444 11.3889 8.27777 10.5278C9.55556 9.22222 9.69444 9.16666 10.1111 9.69445ZM21.5 10.5278C22.3333 11.3889 22.6667 11.9444 22.6667 12.5278C22.6667 13.3333 22.6667 13.3333 21 11.6944C19.7222 10.4444 19.4167 9.97222 19.6667 9.69445C20.0833 9.16666 20.2222 9.22222 21.5 10.5278ZM12.1111 11.6944C12.9444 12.5556 13.1389 12.5556 14.1111 11.6389L14.8889 10.8889L15.6667 11.6389C16.6389 12.5556 16.8333 12.5556 17.6667 11.6944C18.0278 11.3056 18.4444 11 18.6389 11C18.8056 11 19.6111 11.6944 20.4444 12.5278L21.9444 14.0556H14.8889H7.83333L9.33333 12.5278C10.1667 11.6944 10.9722 11 11.1389 11C11.3333 11 11.75 11.3056 12.1111 11.6944ZM13.9167 16L13.1111 16.8333L14.1389 17.8611L15.1667 18.8889L14.1389 19.9444L13.1111 21L13.7778 21.6944L14.4167 22.3889H10.7778H7.1111V18.7778V15.1667H10.9167H14.7222L13.9167 16ZM22.6667 18.7778V22.3889H19.4167C16.2778 22.3889 16.1389 22.3611 15.3889 21.6389L14.6111 20.8889L15.6389 19.8333L16.6667 18.7778L15.6389 17.7222L14.6111 16.6667L15.3611 15.9167C16.1111 15.1944 16.2222 15.1667 19.3889 15.1667H22.6667V18.7778Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1214_56",
    x: -0.958252,
    y: -0.958252,
    width: 31.9167,
    height: 31.9167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1214_56"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1214_56",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1214_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeIconEarthquake708361);
export default __webpack_public_path__ + "static/media/free-icon-earthquake-708361.a2843ee220962ccedc699301b5af9619.svg";
export { ForwardRef as ReactComponent };